import React, { useState } from "react"
import OneResource from "./one-resource"
import { DownIcon, helpIcon, RightArrowIcon, MoveDownIcon } from "src/components/icons-svg"
import CustomTooltip from "src/v2/components/ui-components/custom-tooltip"
import useStore from "src/v2/utils/store"
import useASTStore from "src/v2/utils/AST-store"
import { Box, Table, TableBody, TableCell, TableRow, Typography, Paper, Button } from "@material-ui/core"
import CustomCheckbox from "src/v2/components/form-components/custom-checkbox"
import { makeStyles } from "@material-ui/core/styles"
import HelpOutlineIcon from "@material-ui/icons/HelpOutline"
//@ts-ignore
import { useParams } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  helpIcon: {
    fontSize: '0.8rem', // Smaller icon size
    marginLeft: theme.spacing(0.5),
    color: "#6c7ae0",
    verticalAlign: "middle",
    cursor: "pointer",
  },
}))

// Utility to find a resource by astId from the store
function findResource(astId) {
  const oneReview = useStore.getState().oneReview
  const tabsArray = oneReview?.analyzedData?.json?.tabsArray || []
  for (let tab of tabsArray) {
    let resource = tab.elements.find((x) => x.astId === astId)
    if (resource) return resource
  }
  return null
}

export default function TaskCard({ cardElement, cardId }) {
  const classes = useStyles()
  const [opened, setOpened] = useState(null)
  const [multiSelected, setMultiSelected] = useState(0)
  const completedTasks = useStore((s) => s.completedTasks)
  const setCompletedTasks = useStore((s) => s.setCompletedTasks)
  const saveTasks = useStore((s) => s.saveTasks)
  const testSimulation = useASTStore((s) => s.testSimulation)
  const { reviewId } = useParams()

  const showProgressCheckboxFormalMapping = window["config"]?.SHOW_PROGRESS_CHECKBOX_FORMAL_MAPPING === "YES"

  // Expandable path resources
  if (cardElement.type === "expandable-path-resources") {
    return (
      <Table>
        <TableBody>
          {cardElement.resources.map((cardElementResource) => {
            const solidityResource = findResource(cardElementResource.refernceAstId)
            const isOpened = opened === (solidityResource?.astId || cardElementResource.name)
            return (
              <TableRow key={solidityResource?.astId || cardElementResource.name}>
                <TableCell
                  style={{ verticalAlign: "top", width: 32, cursor: "pointer" }}
                  onClick={() => {
                    if (solidityResource?.astId) {
                      setOpened(solidityResource.astId === opened ? null : solidityResource.astId)
                    } else {
                      setOpened(cardElementResource.name === opened ? null : cardElementResource.name)
                    }
                    setMultiSelected(0)
                  }}
                >
                  {isOpened ? DownIcon() : RightArrowIcon()}
                </TableCell>
                <TableCell>
                  <OneResource
                    resource={cardElementResource.refernceAstId ? solidityResource : cardElementResource}
                    showProgress={false}
                    cardElementType={cardElement.type}
                  />
                  {isOpened && (
                    <Paper elevation={2} style={{ borderRadius: 6, padding: 16, marginTop: 8 }}>
                      {cardElementResource.occurences.length > 1 &&
                        cardElementResource.occurences.map((multi, index) => {
                          const isSelected = index === multiSelected
                          return (
                            <Button
                              key={index}
                              variant={isSelected ? "contained" : "outlined"}
                              color={isSelected ? "primary" : "default"}
                              size="small"
                              style={{
                                marginRight: 8,
                                marginBottom: 8,
                                background: isSelected ? "#D9D9D9" : undefined,
                                color: isSelected ? "black" : "#5D5D5D",
                              }}
                              onClick={() => setMultiSelected(index)}
                            >
                              {index + 1}
                            </Button>
                          )
                        })}
                      {[...cardElementResource.occurences[multiSelected].path]
                        .reverse()
                        .map((path, index, arr) => {
                          const pathLength = arr.length
                          return (
                            <Box key={index} mb={2}>
                              <Paper
                                elevation={index === pathLength - 1 ? 4 : 1}
                                style={{
                                  borderRadius: 5,
                                  border: index === pathLength - 1 ? "4px solid #000AFF" : "1px solid #6b6969",
                                  padding: 12,
                                  cursor: "pointer",
                                  marginBottom: 8,
                                }}
                                onClick={() => {
                                  // You can implement goto logic here if needed
                                }}
                              >
                                <Typography variant="h6">{path.callerName}</Typography>
                                <Typography variant="body2" color="textSecondary" style={{ fontStyle: "italic" }}>
                                  Defined in {path.callerContract} contract
                                </Typography>
                                <Typography variant="body1" style={{ marginTop: 8 }}>
                                  The {path.callerType} <i>{path.callerName}</i> is using the {path.callingOnType} <i>{path.callingOnName}</i> of <i>{path.callingOnContract}</i> contract
                                </Typography>
                              </Paper>
                              {index < pathLength - 1 && (
                                <Box textAlign="center" mb={1}>
                                  {MoveDownIcon(20)}
                                </Box>
                              )}
                            </Box>
                          )
                        })}
                    </Paper>
                  )}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }

  // Task type
  if (cardElement.type === "task") {
    const key = cardId + "_" + cardElement.id
    const isChecked = completedTasks[key] === true
    // eslint-disable-next-line no-inner-declarations
    function setIsChecked(bool) {
      const updated = { ...completedTasks, [key]: bool }
      setCompletedTasks(updated)
      saveTasks(reviewId)
    }
    
    // Don't render task type if showProgressCheckboxFormalMapping is false
    if (!showProgressCheckboxFormalMapping) {
      return null
    }
    
    return (
      <Table>
        <TableBody>
          <TableRow>
            <TableCell
              style={{ verticalAlign: "middle", width: 36, cursor: "pointer", paddingRight: 0, paddingLeft: 0 }}
            >
              <CustomCheckbox
                checked={isChecked}
                label=""
                onChange={setIsChecked}
                style={{ padding: 0, margin: 0 }}
              />
            </TableCell>
            <TableCell style={{ paddingLeft: 8 }}>
              <Box display="flex" alignItems="center">
                <Typography
                  style={{ cursor: "pointer", fontWeight: 500 }}
                  onClick={() => setIsChecked(!isChecked)}
                >
                  {cardElement.title}
                </Typography>
                <CustomTooltip title={cardElement.help || "Help text coming soon"}>
                  <HelpOutlineIcon className={classes.helpIcon} />
                </CustomTooltip>
              </Box>
            </TableCell>
            <TableCell>
              <Button
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                  fontSize: "0.875rem",
                  display: "none",
                }}
                onClick={() => testSimulation && testSimulation(cardElement.id, cardElement.title)}
              >
                Test
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  // Resources flattened
  if (cardElement.type === "resources-flattened") {
    return (
      <Box>
        {cardElement.astIDs.map((res) => {
          const resource = findResource(res)
          return (
            <Box key={resource?.astId} display="inline-block" mr={1} mb={1}>
              <OneResource resource={resource} showProgress={false} />
            </Box>
          )
        })}
      </Box>
    )
  }

  // Expandable resources
  if (cardElement.type === "expandable-resources") {
    return (
      <Table>
        <TableBody>
          {cardElement.resources.map((cardElementResource) => {
            const solidityResource = findResource(cardElementResource.refernceAstId)
            const isOpen = opened?.[solidityResource?.astId]
            return (
              <TableRow key={solidityResource?.astId}>
                <TableCell
                  style={{ verticalAlign: "top", width: 32, cursor: "pointer" }}
                  onClick={() =>
                    setOpened({
                      ...opened,
                      [solidityResource.astId]: !opened?.[solidityResource.astId],
                    })
                  }
                >
                  {isOpen ? "-" : "+"}
                </TableCell>
                <TableCell>
                  <OneResource resource={solidityResource} showProgress={false} />
                  {isOpen && (
                    <Paper style={{ border: "1px solid #cbcbcb", padding: 10, marginTop: 8 }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: cardElementResource.multi[multiSelected]?.expandedHTML,
                        }}
                      />
                      <Box mt={1}>
                        {cardElementResource.multi.map((multi, index) => (
                          <Button
                            key={index}
                            variant={index === multiSelected ? "contained" : "outlined"}
                            color={index === multiSelected ? "primary" : "default"}
                            size="small"
                            style={{ marginRight: 8 }}
                            onClick={() => setMultiSelected(index)}
                          >
                            {index + 1}
                          </Button>
                        ))}
                      </Box>
                    </Paper>
                  )}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }

  // Resources
  if (cardElement.type === "resources") {
    return (
      <Box>
        {cardElement.resources.map((res) => {
          const resource = findResource(res.refernceAstId)
          return (
            <Box key={resource?.astId} display="inline-block" mr={1} mb={1}>
              <OneResource resource={resource} showProgress={false} />
            </Box>
          )
        })}
      </Box>
    )
  }

  // Table
  if (cardElement.type === "table") {
    return (
      <Table style={{ marginBottom: 20, background: "#fbfbfb", border: "1px solid #949494" }}>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} style={{ background: "#dedcdc", padding: "10px 30px", fontWeight: 100 }}>
              <div dangerouslySetInnerHTML={{ __html: cardElement.title }} />
            </TableCell>
          </TableRow>
          <TableRow>
            {cardElement.headers.map((header, idx) => (
              <TableCell key={idx} style={{ padding: "10px 30px" }}>
                {header}
              </TableCell>
            ))}
          </TableRow>
          {cardElement.body.map((row, idx) => (
            <TableRow key={idx}>
              {row.map((cell, cidx) => (
                <TableCell key={cidx} style={{ borderTop: "1px solid #dbdbdb", padding: "10px 30px", fontWeight: 100 }}>
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  // Default fallback
  return null
}